import store from '../../redux/store';
import { EDUCATION, HEALTH } from './misc';

let DYNAMIC_APPLICATION_HEALTH_ID: number | undefined;
let DYNAMIC_APPLICATION_EDUCATION_ID: number | undefined;

const updateGlobalConfig = () => {
  const { applicationConfig } = store.getState().configuration;

  DYNAMIC_APPLICATION_HEALTH_ID = applicationConfig?.find(
    config => config.application_type === HEALTH
  )?.application_request_id;

  DYNAMIC_APPLICATION_EDUCATION_ID = applicationConfig?.find(
    config => config.application_type === EDUCATION
  )?.application_request_id;
};

updateGlobalConfig();

store.subscribe(updateGlobalConfig);

export { DYNAMIC_APPLICATION_HEALTH_ID, DYNAMIC_APPLICATION_EDUCATION_ID };
